import styled, { css, keyframes } from "styled-components";
import { Flex, IconToggleButton, Portal as PortalUI } from "@evergis/ui";

const portalBackgroundAnimate = keyframes`
  from { opacity: 0; }
  to { opacity: 0.65; }
`;

const portalBackground = css`
  &:before {
    content: "";
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: black;
    z-index: 99;
    animation: ${portalBackgroundAnimate} 149ms linear alternate forwards;
  }
`;

export const Portal = styled(PortalUI)<{ shadowedBackground?: boolean }>`
  ${({ shadowedBackground }) => shadowedBackground && portalBackground};
`;

const catalogContainerAnimate = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const DEFAULT_INDEX = 105;

export const CatalogContainer = styled.div<{ asDialog?: boolean; zIndex?: number }>`
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
  top: ${({ asDialog }) => (asDialog ? "5.3%" : "0")};
  left: ${({ asDialog }) => (asDialog ? "3.5%" : "0")};
  background: ${({ theme }) => theme.palette.background};
  width: ${({ asDialog }) => (asDialog ? "93%" : "100%")};
  height: ${({ asDialog }) => (asDialog ? "89.4%" : "100%")};
  z-index: ${({ zIndex = DEFAULT_INDEX }) => zIndex};
  border-radius: ${({ theme: { borderRadius }, asDialog }) => (asDialog ? borderRadius.smallest : "0")};
  box-shadow: ${({ asDialog }) => asDialog && "0 0.1875rem 0.625rem 0 rgba(0, 0, 0, 0.15)"};
  animation: ${({ asDialog }) =>
    asDialog &&
    css`
      ${catalogContainerAnimate} 149ms linear alternate forwards;
    `};
`;

const createCardsWidthMedia = (count: number, padding: number, width: number) => css`
  @media screen and (min-width: ${width * count + padding}rem) and (min-height: 44rem) {
    width: ${width * count}rem;
  }
`;

const createCardsWidthMediaCompact = (count: number, padding: number, width: number) => css`
  @media screen and (min-width: ${width * count + padding}rem) and (max-height: 44rem) {
    width: ${width * count}rem;
  }
`;

/* eslint-disable @typescript-eslint/no-magic-numbers */
// TODO write better media query helpers
export const catalogWidth = css`
  ${createCardsWidthMedia(2, 5, 23.5)};
  ${createCardsWidthMedia(3, 5, 23.5)};
  ${createCardsWidthMedia(4, 5, 23.5)};
  ${createCardsWidthMedia(5, 5, 23.5)};
  ${createCardsWidthMedia(6, 5, 23.5)};
`;

export const catalogInDialogWidth = css`
  ${createCardsWidthMedia(2, 10, 23.5)};
  ${createCardsWidthMedia(3, 10, 23.5)};
  ${createCardsWidthMedia(4, 11, 23.5)};
  ${createCardsWidthMedia(5, 12, 23.5)};
  ${createCardsWidthMedia(6, 13, 23.5)};
`;

export const catalogCompactWidth = css`
  @media screen and (max-height: 44rem) {
    width: 20.5rem;
  }

  ${createCardsWidthMediaCompact(2, 5, 20.5)};
  ${createCardsWidthMediaCompact(3, 5, 20.5)};
  ${createCardsWidthMediaCompact(4, 5, 20.5)};
  ${createCardsWidthMediaCompact(5, 5, 20.5)};
  ${createCardsWidthMediaCompact(6, 5, 20.5)};
`;

export const catalogInDialogCompactWidth = css`
  @media screen and (max-height: 44rem) {
    width: 20.5rem;
  }

  ${createCardsWidthMediaCompact(2, 9, 20.5)};
  ${createCardsWidthMediaCompact(3, 10, 20.5)};
  ${createCardsWidthMediaCompact(4, 11, 20.5)};
  ${createCardsWidthMediaCompact(5, 12, 20.5)};
  ${createCardsWidthMediaCompact(6, 13, 20.5)};
`;

export const SharedButtonContainer = styled(Flex)`
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;

  ${IconToggleButton}:not(:last-child) {
    margin-right: 1rem;
  }

  @media screen and (min-width: 86.875rem) {
    white-space: nowrap;
  }
`;
